import {Button} from '@mui/material';
import BackSvg from 'assets/img/form-backbtn.svg';

const BackButton = ({backStepHandler}) => {
  return (
    <Button
      onClick={backStepHandler}
      sx={{
        borderRadius: '50%',
        minWidth: '26px',
        height: '26px',
        background: '#FFFFFF',
        padding: 0,
        border: '1px solid #F5F5F5',
        boxShadow: '-2px -2px 7px #FFFFFF, 1px 1px 10px rgba(0, 0, 0, 0.10)',
      }}>
      <img src={BackSvg} alt='' />
    </Button>
  );
};

export default BackButton;
